import Vue from 'vue'
import accounting from 'accounting-js'

export default {

    rand() { return parseInt(Math.random() * 1000000 + Math.random() * 10000000000) },
    randn() { return this.rand() * -1 },

    linkCartao: arquivo => arquivo ? require('@/aplicacao/_assets/imagens/cartoes/' + arquivo) : '',

    linkLogoCliente: arquivo => arquivo ? process.env.VUE_APP_NUCLEO_BASE_CAMINHOS_CLIENTES_LOGOS + '/' + arquivo : '',

    linkLogoMarca: arquivo => arquivo ? process.env.VUE_APP_NUCLEO_BASE_CAMINHOS_MARCAS_LOGOS + '/' + arquivo : '',

    linkRodape: arquivo => arquivo ? process.env.VUE_APP_NUCLEO_BASE_CAMINHOS_CLIENTES_RODAPES + '/' + arquivo : '',

    linkProduto: arquivo => arquivo ? process.env.VUE_APP_NUCLEO_BASE_CAMINHOS_PRODUTOS + '/' + arquivo : '',

    linkRastreioCorreios: (codigoDeRastreio) => codigoDeRastreio ? `https://www.linkcorreios.com.br/?id=${codigoDeRastreio}` : 'https://www.linkcorreios.com.br',

    obterUrlEncurtada(url) {
        return new Promise(function(resolve, reject) {
            Vue.http.post('url-encurtada', { url })
                .then(res => res.json())
                .then(res => { resolve(res.dados.link) })
                .catch(err => { resolve(url) })
        })
    },

    formatarInteiro: valor => !valor ? 0 : accounting.formatMoney(valor, { symbol: '', format: '%v', decimal: ',', thousand: '.', precision: 0, }),
    formatarFloat1: valor => !valor ? 0.0 : accounting.formatMoney(valor, { symbol: '', format: '%v', decimal: ',', thousand: '.', precision: 1, }),
    formatarFloat2: valor => !valor ? 0.0 : accounting.formatMoney(valor, { symbol: '', format: '%v', decimal: ',', thousand: '.', precision: 2, }),
    formatarMoeda: valor => !valor ? 'R$ 0,00' : accounting.formatMoney(valor, { symbol: 'R$', format: '%s %v', decimal: ',', thousand: '.', precision: 2, }),
    formatarPorcentagem0: (valor, total) => !valor ? '0%' : accounting.formatMoney((valor * 100 / total), { symbol: '%', format: '%v%s', decimal: ',', thousand: '.', precision: 0, }),
    formatarPorcentagem1: (valor, total) => !valor ? '0,0%' : accounting.formatMoney((valor * 100 / total), { symbol: '%', format: '%v%s', decimal: ',', thousand: '.', precision: 1, }),
    formatarPorcentagem2: (valor, total) => !valor ? '0,00%' : accounting.formatMoney((valor * 100 / total), { symbol: '%', format: '%v%s', decimal: ',', thousand: '.', precision: 2, }),
    formatarVolume: valor => !valor ? '0 cx' : accounting.formatMoney(valor, { symbol: 'cx', format: '%v %s', decimal: ',', thousand: '.', precision: 0, }),
    formatarPPC: valor => !valor ? '-----/-----' : accounting.formatMoney(valor, { symbol: 'R$', format: '%s %v', decimal: ',', thousand: '.', precision: 2, }),

    humanizar: param => param ? param.toLowerCase().split(' ')
        .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1)).join(' ')
        .replace(' Da', ' da').replace(' De', ' de').replace(' Do', ' do') : '',

    extensaoArquivo(arquivo) {
        return arquivo ? arquivo.split('.').pop() : ''
    },

    iconeExtensao(extensao) {

        let icone = 'file'

        if (['xls', 'xlsx', 'ods'].includes(extensao)) icone = 'file-excel'
        else if (['doc', 'docx', 'odt'].includes(extensao)) icone = 'file-word'
        else if (['ppt', 'pptx', 'odp', 'pps', 'ppsx'].includes(extensao)) icone = 'file-powerpoint'
        else if (['pdf'].includes(extensao)) icone = 'file-pdf'
        else if (['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg', 'psd', 'tiff', 'ai', 'cdr'].includes(extensao)) icone = 'file-image'
        else if (['mpeg', 'rmvb', 'mp4', 'mov', 'avi', 'wmv', 'flv', 'fla', 'swf', 'mkv', 'qt', 'mpeg4'].includes(extensao)) icone = 'file-video'
        else if (['zip', 'rar'].includes(extensao)) icone = 'file-archive'
        else if (['rtf', 'txt'].includes(extensao)) icone = 'file-alt'
        else if (['wav', 'mp3', 'flac', 'ape', 'wma', 'aac', 'ogg', 'alac', 'aiff', 'pcm'].includes(extensao)) icone = 'file-audio'

        return icone

    },

    iconeArquivo(arquivo) {
        let extensao = this.extensaoArquivo(arquivo)
        let icone = this.iconeExtensao(extensao)
        return icone
    },

    slugify(texto) {

        let str = texto

        str = str.replace(/^\s+|\s+$/g, '')

        str = str.toLowerCase()

        let de   = 'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;';
        let para = 'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------';

        for (let i = 0, l = de.length; i < l; i++) {
            str = str.replace(new RegExp(de.charAt(i), 'g'), para.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')

        return str

    },

}
